
var listCollections = document.querySelectorAll('.list-collections')

listCollections.forEach(section =>{
    var cardLink = section.querySelectorAll('.collection-card__link')
    function printScreenWidth() {
        
        var secreenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (secreenWidth < 767) {
            cardLink.forEach((cl,i) =>{
                if (i > 5) {
                    cl.classList.add('dis_none')
                }
            })
        }else{
            cardLink.forEach((cl,i) =>{
                if (i > 5) {
                    cl.classList.remove('dis_none')
                }
            })
        }
    }
    printScreenWidth()
    // 监听屏幕resize事件
    window.addEventListener('resize',()=>{
        printScreenWidth()
    } )
})